<script setup lang="ts">
  // テキスト上のリンクをNuxtLinkに変換して表示するコンポーネント
  interface Props {
    text: string;
  }
  const props = defineProps<Props>();

  const splitTexts = computed<string[]>(() => {
    return props.text.split(/(https?:\/\/[^\s]*)/i);
  });
</script>

<template>
  <template v-for="(item, i) in splitTexts" :key="i">
    <NuxtLink v-if="i % 2" :to="item" target="_blank" class="nuxt-link">
      <span class="text-main-01">
        {{ item }}
      </span>
    </NuxtLink>
    <span v-else>{{ item }}</span>
  </template>
</template>

<style lang="scss" scoped>
  .nuxt-link {
    text-decoration: none;
  }
</style>
